// extracted by mini-css-extract-plugin
module.exports = {"sectionSettings":"CourseGrid_sectionSettings__3QZH0","sectionHeading":"CourseGrid_sectionHeading__2teu6"};